export default class AlertModal {
    constructor() {
        this.modalSelector = '.alert-modal';
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    show(text, head = null) {
        let modal = $(this.modalSelector);
        modal.find('.modal-body').html(text);
        modal.find('.modal-header-content').text(head);
        modal.modal('show');
    }

    hide() {
        $(this.modalSelector).modal('hide');
    }
}
